import { Chip as MuiChip, type ChipProps as MuiChipProps } from '@mui/material';

import { alpha, darken, styled } from '@mui/material/styles';

type ChipProps = MuiChipProps & {
    selected?: boolean;
    disabled?: boolean;
};

const Chip = styled(
    (
        props: ChipProps = {
            selected: false,
            disabled: false,
        }
    ) => <MuiChip {...props} />
)(({ theme, ...props }) => {
    let color = theme.palette.primary.main;
    let background = alpha(theme.palette.primary.main, 0.12);
    let backgroundHover = alpha(background, 0.2);
    if (props.selected) {
        color = theme.palette.secondary.main;
        background = theme.palette.primary.itemSelectedBackground;
        backgroundHover = darken(background, 0.1);
    }
    if (props.disabled) {
        color = theme.palette.primary.inactive;
    }

    return {
        borderRadius: '4px',
        '& .MuiChip-label': {
            ...theme.typography.body2,
            color,
        },
        '& .MuiSvgIcon-root': {
            fontSize: '18px',
            color: theme.palette.primary.inactive,
        },
        background,
        '&:hover': {
            background: backgroundHover,
        },
    };
});
export default Chip;
